/* eslint-disable import/prefer-default-export */
import { useCurrentUser, useTenantBusiness } from '@centecomm/portal-service-react';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadStatus } from '../../../Types';
import { BusinessActions, BusinessActionTypes } from '../actions';
import { mapBusinessInformationUserAPIToBusinessUser } from '../Mappers/mapBusinessInformationUserAPIToBusinessUser';
import * as selectors from '../selectors';
import { BusinessUser } from '../Types';

type BusinessUsersFromStateHook = (occupantId: number | string) => {
    areLoaded: boolean;
    areLoading: boolean;
    hasError: boolean;
    loadState: LoadStatus;
    users: BusinessUser[];
};

export const useBusinessUsersFromState: BusinessUsersFromStateHook = (occupantId: number | string) => {
    const dispatch = useDispatch();

    const { currentUserId } = useCurrentUser();

    const loadState: LoadStatus = useSelector(selectors.businessUsersOccupantLoadStatus(occupantId));
    const sortedBusinessUsers: BusinessUser[] = useSelector(selectors.sortedBusinessUsersForOccupant(occupantId));

    const { getBusinessUsers } = useTenantBusiness();

    React.useEffect(() => {
        if (loadState === LoadStatus.INITIAL_STATE) {
            dispatch({
                type: BusinessActions.LOAD_BUSINESS_USERS_FOR_OCCUPANT,
                payload: occupantId,
            } as BusinessActionTypes);

            getBusinessUsers(+occupantId)
                .then((fetchedBusinessUsers) => {
                    dispatch({
                        type: BusinessActions.SET_BUSINESS_USERS_FOR_OCCUPANT,
                        payload: {
                            occupantId,
                            users: fetchedBusinessUsers.map((user) => mapBusinessInformationUserAPIToBusinessUser(user)),
                        },
                    } as BusinessActionTypes);
                })
                .catch((error) => {
                    dispatch({
                        type: BusinessActions.SET_BUSINESS_USERS_FOR_OCCUPANT_ERROR_STATE,
                        payload: {
                            errorMessage: error?.code
                                ? error.code
                                : 'We were not able to load your business users at this time.',
                        },
                    });
                });
        }
    }, [loadState]);

    return {
        areLoaded: loadState === LoadStatus.LOADED,
        areLoading: loadState === LoadStatus.PENDING,
        hasError: loadState === LoadStatus.ERROR,
        loadState,
        // Remove self from list of editable users
        users: sortedBusinessUsers.filter(({ id }: BusinessUser) => id !== currentUserId),
    };
};
